import { gql } from '@apollo/client';

export default gql`
  mutation rejectDocument(
    $documentId: String!
    $documentType: String!
    $note: String
  ) {
    rejectDocument(
      documentId: $documentId
      documentType: $documentType
      note: $note
    ) {
      ok
      message
      error
    }
  }
`;
